export class EconomicGroup {
    constructor({
                    //attributes
                    id = null,
                    company_id = null,
                    name = '',
                } = {}) {
        this.id = id;
        this.company_id = company_id;
        this.name = name;
    }

}

export function createEconomicGroup(data={}) {
    return Object.freeze(new EconomicGroup(data));
}